// frontend/src/services/studentService.js
import api from './api'; // IMPORTANT: Import our new api instance

// The base path for students, the base URL is already in the api instance
const STUDENTS_API_PATH = '/students';

export const getAllStudents = async (filters = {}) => {
    try {
        // Build query params from filters
        const params = new URLSearchParams();
        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
                params.append(key, filters[key]);
            }
        });
        const queryString = params.toString();
        const url = queryString ? `${STUDENTS_API_PATH}?${queryString}` : STUDENTS_API_PATH;
        // Note: We use 'api.get' now, not 'axios.get'
        const response = await api.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching students:", error);
        throw error;
    }
};

export const createStudent = async (studentData) => {
    try {
        const response = await api.post(STUDENTS_API_PATH, studentData);
        return response.data;
    } catch (error) {
        console.error("Error creating student:", error);
        throw error;
    }
};

export const updateStudent = async (id, studentData) => {
    try {
        const response = await api.put(`${STUDENTS_API_PATH}/${id}`, studentData);
        return response.data;
    } catch (error) {
        console.error(`Error updating student with id ${id}:`, error);
        throw error;
    }
};

export const deleteStudent = async (id) => {
    try {
        await api.delete(`${STUDENTS_API_PATH}/${id}`);
    } catch (error) {
        console.error(`Error deleting student with id ${id}:`, error);
        throw error;
    }
};

export const restoreStudent = async (id) => {
    try {
        const response = await api.post(`${STUDENTS_API_PATH}/${id}/restore`);
        return response.data;
    } catch (error) {
        console.error(`Error restoring student with id ${id}:`, error);
        throw error;
    }
};

export const getStudentReportCard = async (id) => {
    try {
        const response = await api.get(`${STUDENTS_API_PATH}/${id}/report-card`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching report card for student ${id}:`, error);
        throw error;
    }
};

export const getStudentById = async (id) => {
    try {
        const response = await api.get(`${STUDENTS_API_PATH}/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching student with id ${id}:`, error);
        throw error;
    }
};

export const assignRollNumbers = async (classId, enrollments) => {
    try {
        const response = await api.post('/enrollments/update-roll-numbers', {
            classId,
            enrollments,
        });
        return response.data;
    } catch (error) {
        console.error('Error assigning roll numbers:', error);
        throw error;
    }
};

export const importStudents = async (formData, classId) => {
    // Note the classId is passed as a query parameter
    const response = await api.post(`${STUDENTS_API_PATH}/import?classId=${classId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};


export const bulkUpdateStudents = async (students) => {
    try {
        // The endpoint should be '/students/bulk-update' based on the backend route
        const response = await api.put(`${STUDENTS_API_PATH}/bulk-update`, { students });
        return response.data;
    } catch (error) {
        console.error('Error bulk updating students:', error);
        throw error;
    }
};

export const exportStudentsAsCSV = async (classId) => {
    try {
        const response = await api.get(`${STUDENTS_API_PATH}/export/class/${classId}`, {
            responseType: 'blob'
        });

        // Create a blob from the response
        const blob = new Blob([response.data], { type: 'text/csv' });

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger download
        const link = document.createElement('a');
        link.href = url;
        link.download = `students_export_${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return response.data;
    } catch (error) {
        console.error('Error exporting students as CSV:', error);
        throw error;
    }
};

export const saveReportCardNote = async (studentId, academicYear, noteContent) => {
    try {
        const response = await api.post(`${STUDENTS_API_PATH}/${studentId}/report-card-note`, {
            academicYear,
            noteContent
        });
        return response.data;
    } catch (error) {
        console.error('Error saving report card note:', error);
        throw error;
    }
};

export const uploadStudentProfilePicture = async (studentId, file) => {
    try {
        const formData = new FormData();
        formData.append('profilePicture', file);
        const response = await api.post(`${STUDENTS_API_PATH}/${studentId}/upload-picture`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    } catch (error) {
        console.error(`Error uploading profile picture for student ${studentId}:`, error);
        throw error;
    }
};